import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 26, className, as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.75, delay, ease: EASE }}
    >
      {children}
    </MotionTag>
  );
};

export const Chapter = ({ num, label, testId }) => (
  <Reveal className="mb-12 sm:mb-16" data-testid={testId}>
    <div className="flex items-center gap-5">
      <span className="font-mono text-xs sm:text-sm tracking-[0.28em] text-accent">
        {num}
      </span>
      <span className="h-px flex-1 bg-line" />
    </div>
    <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-[3.25rem] font-extrabold tracking-tight text-ink leading-[1.05]">
      {label}
    </h2>
  </Reveal>
);
